export default __webpack_public_path__ + "static/media/background.bf248db3.png";